import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import TextFilterChips from '@/components/Search/RightPane/TextFilterChips.vue';
import TextFilterInput from '@/components/Search/RightPane/TextFilterInput.vue';
import { computed, ComputedRef, onUnmounted, PropType } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  props: {
  suggestions: {
    type: Object as PropType<Set<string>>,
  },
},
  setup(__props) {



const store = useStore();

const filters: ComputedRef<Set<string>> = computed(() => store.getters['textFilter/filters']);

const submit = async (filter: string) => {
  if (filter === '') {
    // empty filter, do nothing
  } else {
    await store.dispatch('textFilter/add', filter);
  }
};

const removeFilter = async (filter: string) => {
  await store.dispatch('textFilter/delete', filter);
};

const removeAllFilters = async () => {
  await store.dispatch('textFilter/clear');
};

onUnmounted(() => {
  // reset filters
  store.dispatch('textFilter/clear');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TextFilterInput, {
      onSubmit: submit,
      "highlight-icon": _unref(filters) && _unref(filters).size > 0,
      suggestions: __props.suggestions
    }, null, 8, ["highlight-icon", "suggestions"]),
    (_unref(filters) && _unref(filters).size > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(TextFilterChips, {
            class: "pt-2",
            filters: _unref(filters),
            onRemove: removeFilter,
            onRemoveAll: removeAllFilters
          }, null, 8, ["filters"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})